import { createFileRoute } from "@tanstack/react-router";
import { Connections } from "@/features/oauth/Connections";

export const Route = createFileRoute("/_authenticated/_protected/settings/connections")({ component: Connections });
